import { RootState } from '@reducers/index';
import { AssessmentChallenge } from 'src/types/shared/Assessments';

export const getAssessmentChallengesIsFetching = (state: RootState): boolean =>
    state.assessmentChallengesReducer.isFetching;
export const getAssessmentChallengesFetchError = (state: RootState): string | null =>
    state.assessmentChallengesReducer.fetchError;

export const getAssessmentChallenges = (state: RootState): Record<number, AssessmentChallenge> =>
    state.assessmentChallengesReducer.assessmentChallenges;
export const getAssessmentChallenge = (state: RootState, id: number): AssessmentChallenge =>
    state.assessmentChallengesReducer.assessmentChallenges[id];
